if (typeof document === "undefined") return;
var extractCssCreateStylesheet = function (
	chunkId, fullhref, oldTag, resolve, reject, fetchPriority
) {
	var linkTag = document.createElement("link");
linkTag.setAttribute("data-vanilla-extract", "true");

linkTag.rel = "stylesheet";

linkTag.type = "text/css";

if (__webpack_require__.nc) {
  linkTag.nonce = __webpack_require__.nc;
}
linkTag.href = fullhref;


if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
  linkTag.crossOrigin = 'anonymous';
}


	var onLinkComplete = function (event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	if (oldTag) {
            oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
          } else {
            document.head.appendChild(linkTag);
          }
	return linkTag;
}
var extractCssFindStylesheet = function (href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for (var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if (dataHref) {
			dataHref = dataHref.split('?')[0]
		}
		if (tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}

	var existingStyleTags = document.getElementsByTagName("style");
	for (var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if (dataHref === href || dataHref === fullhref) return tag;
	}
}

var extractCssLoadStylesheet = function (chunkId, fetchPriority) {
	return new Promise(function (resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if (extractCssFindStylesheet(href, fullhref)) return resolve();
		extractCssCreateStylesheet(chunkId, fullhref, null, resolve, reject, fetchPriority);
	})
}

// object to store loaded CSS chunks
var installedCssChunks = {
	3808: 0,

};

__webpack_require__.f.miniCss = function (chunkId, promises, fetchPriority) {
	var cssChunks = {
1332: 1,
1428: 1,
1444: 1,
1672: 1,
1681: 1,
1946: 1,
1959: 1,
1986: 1,
2006: 1,
2111: 1,
2128: 1,
214: 1,
230: 1,
2336: 1,
2366: 1,
2372: 1,
23: 1,
2532: 1,
2608: 1,
2616: 1,
2627: 1,
2629: 1,
2853: 1,
2867: 1,
2915: 1,
2979: 1,
3188: 1,
3233: 1,
325: 1,
3298: 1,
3352: 1,
3424: 1,
343: 1,
3442: 1,
3543: 1,
3721: 1,
3722: 1,
3723: 1,
3755: 1,
3760: 1,
3816: 1,
4007: 1,
4010: 1,
4340: 1,
4398: 1,
4501: 1,
452: 1,
4622: 1,
482: 1,
4873: 1,
4910: 1,
4971: 1,
4980: 1,
5192: 1,
5538: 1,
5639: 1,
5657: 1,
5697: 1,
5713: 1,
5958: 1,
5980: 1,
6196: 1,
6434: 1,
6481: 1,
6495: 1,
6506: 1,
6833: 1,
689: 1,
6908: 1,
691: 1,
7023: 1,
7029: 1,
7062: 1,
7232: 1,
7255: 1,
7334: 1,
7348: 1,
7478: 1,
7512: 1,
760: 1,
7689: 1,
7691: 1,
7901: 1,
8101: 1,
8143: 1,
8235: 1,
8418: 1,
8517: 1,
8557: 1,
861: 1,
8682: 1,
8732: 1,
8750: 1,
8848: 1,
8978: 1,
9066: 1,
9144: 1,
918: 1,
9338: 1,
9339: 1,
9390: 1,
9892: 1,
9908: 1,

};
	if (installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId])
	else if (installedCssChunks[chunkId] !== 0 && cssChunks[chunkId])
		promises.push(
			installedCssChunks[chunkId] = extractCssLoadStylesheet(chunkId, fetchPriority).then(
				function () {
					installedCssChunks[chunkId] = 0;
				},
				function (e) {
					delete installedCssChunks[chunkId];
					throw e;
				}
			)
		)
}

// no hmr
// no prefetch
// no preload